const hasPointEvent: boolean = !!window.PointerEvent;

const getPointEvent = () => {
  return hasPointEvent ? "onPointerDown" : "onMouseDown";
};

export { hasPointEvent, getPointEvent };
